import navigationHelper from "../../assets/navigation-helper";
import FormBaseController from "../form_base_controller";

export default class extends FormBaseController {

    connect() {
        super.connect();
        this._cartId = null;
        this.$paymentType = this.element.querySelector("#cart_data-payment_type");
        if (this.$paymentType) {
            this.$paymentType.addEventListener("change", event => this.onPaymentTypeChange(event));
        } else {
            console.warn("#cart_data-payment_type not found.")
        }
    }

    onPaymentTypeChange() {
        let url = "/cart/index/index/";
        var cart_id = this.cartId;
        if (cart_id) {
            url += "id/" + cart_id + "/";
        }
        url += "payment_type/" + this.$paymentType.value + "/";
        navigationHelper.goto(url);
    }

    get cartId() {
        if (!this._cartId) {
            const element = document.querySelector("#cart_data-cart_id");
            this._cartId = element && element.value;
        }
        return this._cartId;
    }
}
